import { runDemo } from "../shared/demoRunner";
import { createYetiScene } from "./scene";

runDemo({
    createScene: createYetiScene,
});
